import React from 'react';
import {useFetchLocations} from '../../hooks';
import {customCountriesFilter} from '../../utils/customCountriesFilter';
import {Select, SelectProps, SelectRefType} from '@guestapp/old-ui-kit';

type Props = Omit<SelectProps, 'options'>;
const CountriesSelectInternal = (
  props: Props,
  ref: React.ForwardedRef<SelectRefType>,
) => {
  const {locationsAsOptions} = useFetchLocations();

  return (
    <Select
      {...props}
      ref={ref}
      filterOption={customCountriesFilter}
      options={locationsAsOptions}
    />
  );
};

export const CountriesSelect = React.forwardRef(CountriesSelectInternal) as (
  props: Props & {ref?: React.ForwardedRef<SelectRefType>},
) => ReturnType<typeof CountriesSelectInternal>;
